<template>
	<div class="filters">
		<div id="endsBy" v-if="isFilterAvailable('endsBy')">
			<button
				v-for="month in monthKeys"
				:key="month"
				:class="{ selected: parseInt(month, 10) === filters.endsBy }"
				@click="
					$emit('toggle-filter', {
						filter: 'endsBy',
						value: parseInt(month, 10),
					})
				"
			>
				{{ months[month].toLowerCase().slice(0, 3) }}
			</button>
		</div>
		<div id="availableBy" v-if="isFilterAvailable('availableBy')">
			<button
				v-for="month in monthKeys"
				:key="month"
				:class="{ selected: parseInt(month, 10) === filters.availableBy }"
				@click="
					$emit('toggle-filter', {
						filter: 'availableBy',
						value: parseInt(month, 10),
					})
				"
			>
				{{ months[month].toLowerCase().slice(0, 3) }}
			</button>
		</div>
		<div id="hoursBy" v-if="isFilterAvailable('hoursBy')">
			<button
				v-for="hour in hourKeys"
				:key="hour"
				:class="{ selected: hour === filters.hoursBy }"
				@click="$emit('toggle-filter', { filter: 'hoursBy', value: hour })"
			>
				{{ `0${hour}`.slice(-2) }}
			</button>
		</div>
		<div id="donated" v-if="isFilterAvailable('donated')">
			<button
				v-for="value in [true, false]"
				:key="value.toString()"
				:class="{ selected: value === filters.donated }"
				@click="$emit('toggle-filter', { filter: 'donated', value })"
			>
				{{ value }}
			</button>
		</div>
	</div>
</template>

<script>
import { months } from '@/assets/data';

export default {
	props: ['filters', 'filtersAvailable'],
	data: () => ({
		months,
		monthKeys: [...Object.keys(months)],
		hourKeys: [...new Array(24).keys()],
	}),
	methods: {
		isFilterAvailable: function (f) {
			return this.filtersAvailable.indexOf(f) !== -1;
		},
	},
};
</script>

<style lang="scss">
#endsBy::before {
	content: 'ends by';
}
#availableBy::before {
	content: 'available by';
}
#hoursBy::before {
	content: 'hours';
}
#donated::before {
	content: 'donated';
}
</style>
